<template>
  <!-- 帮助文档编辑 -->
  <div class="EditKnow">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title"></page-header>
    <!-- 表单 -->
    <el-scrollbar
      style="
        height: calc(100% - 60px);
        padding-top: 20px;
        box-sizing: border-box;
      "
    >
      <el-form
        :model="addForm"
        label-position="rigth"
        label-width="120px"
        :rules="addFormRule"
        ref="addForm"
      >
        <!-- <div class="form-item-warp">
          <el-form-item label="所属父类标题" prop="parentId">
            <el-select
              v-model="addForm.parentId"
              placeholder="所属父类标题"
              style="width: 200px"
            >
              <el-option
                v-for="(item, index) in parentList"
                :key="index"
                :label="item.title"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div> -->
        <div class="form-item-warp">
          <el-form-item label="文章标题" prop="title">
            <el-input v-model="addForm.title" style="width: 200px"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-warp">
          <el-form-item label="摘要" prop="zhaiyao">
            <el-input v-model="addForm.zhaiyao" style="width: 200px"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-warp">
          <el-form-item label="链接" prop="link_url">
            <el-input
              v-model="addForm.link_url"
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-warp">
          <el-form-item label="排序值" prop="sort_id">
            <el-input-number
              v-model="addForm.sort_id"
              :min="1"
              style="width: 200px"
            ></el-input-number>
          </el-form-item>
        </div>
        <div class="form-item-warp">
          <el-form-item label="文章内容" prop="content">
            <!-- <wang-editor :value="addForm.content" @change="change" style="width:800px"></wang-editor> -->
            <tinymce
              :value="addForm.content"
              @input="change"
              :isEditorLoad="isEditorLoad"
              style="width: 800px"
            ></tinymce>
          </el-form-item>
        </div>
        <div class="form-item-wrap" style="margin-top: 20px">
          <el-form-item>
            <el-button type="primary" @click="submitForm">提交</el-button>
            <el-button type="info" @click="resetForm">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-scrollbar>
  </div>
</template>

<script>
//组件
// import WangEditor from "@/components/WangEditor.vue";
import Tinymce from "@/components/Tinymce";
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "EditKnow",
  data() {
    return {
      id: "",
      channel_Id: "",
      bj_id: 0,
      //新增表单
      addForm: {
        category_id: "",
        channel_id: "",
        tags: "",
        sort_id: "",
        title: "",
        zhaiyao: "",
        link_url: "",
        img_url: "",
        content: "",
        id: 0,
      },
      addFormRule: {
        parentId: [mustFill],
        title: [mustFill],
        sort: [mustFill],
      },
      parentList: [],
      isEditorLoad: false, // 编辑器是否加载完成
    };
  },
  components: {
    Tinymce,
  },
  mounted() {
    let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
    if (prams) {
      this.id = prams.id;
      this.channel_Id = prams.channel_id;
      this.bj_id = prams.bjId;
      console.log(prams.bjId, "prams.bjIdprams.bjId");
      if (prams.bjId !== undefined) {
        this.getData();
      }
    }
    this.getParentList();
  },
  methods: {
    /**富文本编辑内容改变回调 */
    change(val) {
      this.addForm.content = val;
    },
    /**返回上一页 */
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },
    // 获取基础数据
    getData() {
      let data = {
        id: this.bj_id,
        entId: window.localStorage.getItem("entId"),
      };
      this.$request({
        method: "post",
        url: "Base/GetCategoryDocument",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            let data = res.dataModel;
            this.addForm.tags = data.tags;
            this.addForm.sort_id = 1;
            this.addForm.title = data.title;
            this.addForm.zhaiyao = data.zhaiyao;
            this.addForm.link_url = data.link_url;
            this.addForm.img_url = data.img_url;
            this.addForm.content = decodeURIComponent(atob(data.content));
            this.bj_id = data.id;
            // this.addForm.parentId = data.parent_id;
            // this.addForm.title = data.title;
            // this.addForm.zaiyao = data.zaiyao;
            // this.addForm.zaiyao = data.zaiyao;
            // this.addForm.sort = data.sort_id;
            // this.addForm.content = decodeURIComponent(atob(data.content));
            // this.addForm.Id = data.id; //序号
            // this.addForm.channel_id = data.channel_id;
            // this.addForm.parent_id = data.parent_id; //上级ID
            // this.addForm.link_url = ""; //链接地址
            // this.addForm.img_url = ""; //图片地址
            // this.addForm.entId = window.localStorage.getItem("entId"); //企业ID
            // this.addForm.lastmodifytime = null;
            this.isEditorLoad = true;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 获取父级列表
    getParentList() {
      let data = {
        entId: window.localStorage.getItem("entId"),
        channel_id: "19",
        pageIndex: 1,
        pageSize: "9999",
        sqlValue: "",
        keyId: 0,
      };
      this.$request({
        url: "/Base/GetTableCategory",
        method: "post",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.parentList = res.list;
            this.addForm.category_id = this.id.toString;
            console.log(this.addForm.category_id, this.id);
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**提交表单 */
    submitForm() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let data = {
            category_id: this.id,
            tags: this.addForm.tags,
            sort_id: this.addForm.sort_id,
            title: this.addForm.title,
            zhaiyao: this.addForm.zhaiyao,
            link_url: this.addForm.link_url,
            img_url: this.addForm.img_url,
            content: btoa(encodeURIComponent(this.addForm.content)),
            id: this.bj_id || 0,
            entId: window.localStorage.getItem("entId"),
            channel_id: "19",
          };
          this.$request({
            method: "post",
            url: "Base/EditCategoryDocument",
            data: data,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.goBack();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },
    /**重置表单 */
    resetForm() {
      this.$refs["addForm"].resetFields();
      this.addForm.parentId = this.parentList[0].value;
    },
  },
};
</script>

<style scoped>
.EditKnow {
  width: 100%;
  height: 100%;
}
</style>
